(function () {
    /**
     * Parse event data from fullcalendar
     *
     * @param {object} event
     * @returns {object} data
     */
    var EventData = function(event) {
        var moment = require('moment');
        var data = {
            id: event.id,
            allDay: event.allDay,
            title: event.title,
            dates: {
                start: event.start,
                end: event.end
            },
            color: event.color,
            booking: event.data.booking.name,
            links: event.data.links,
            conflictGroup: event.data.conflictGroup,
            pending: event.data.pending,
            artists: event.data.booking.artists,
            jsEvent: {
                posX: 0,
                posY: 0
            },
            getDate: function() {
                var start = this.dates.start,
                    end = this.dates.end,
                    dateStart = moment(start).format('ddd DD MMMM'),
                    timeStart = moment(start).format('HH:mm'),
                    dateEnd = null,
                    timeEnd = null;

                if (end !== null) { // have end date
                    dateEnd = moment(end).format('ddd DD MMMM'),
                    timeEnd = moment(end).format('HH:mm');

                    if (!this.allDay) {
                        if (dateStart === dateEnd) { // single day
                            return dateStart + ', ' + timeStart + ' – ' + timeEnd;
                        } else {
                            return dateStart + ', ' + timeStart + ' – ' + dateEnd + ', ' + timeEnd;
                        }
                    } else {
                        return dateStart + ' – ' + dateEnd;
                    }

                } else {
                    return dateStart + (event.allDay ? '' : ', ' + timeStart);
                }
            },
            getTime: function() {
                var start = this.dates.start,
                    end = this.dates.end,
                    timeStart = moment(start).format('HH:mm'),
                    timeEnd = null;

                if (this.allDay) {
                    return 'Toute la journée';
                } else if (end !== null) { // have end date
                    timeEnd = moment(end).format('HH:mm');
                    return timeStart + ' – ' + timeEnd;
                } else {
                    return timeStart;
                }
            },
            showConflict: function() {
                if (typeof this.conflictGroup !== 'undefined') {
                    if (this.id !== this.conflictGroup.initiator) {
                        return true;
                    } else {
                        return true; //false;
                    }
                }
            }
        };

        return data;
    };

    module.exports = EventData;
})();
